import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { botanyData } from '../../data/departmentalData/botany';

const Botany = () => {
  return <TemplatePage data={botanyData} />;
};

export default Botany;